module.exports = __webpack_public_path__ + "static/media/blog3.23a9c4ac.png";